// 入力が落ち着いてから絞り込むまでの待ち時間
const DEBOUNCE_DELAY_MS = 200

// 全角英数・半角カナなどの表記ゆれを吸収するため、NFKC正規化してから比較する
const normalize = (text) => text.normalize('NFKC').toLowerCase()

// キーワードで質問を絞り込む検索処理
export function initFaqSearch() {
  const searchInput = document.querySelector('.js-faq-search')
  if (!searchInput) return

  const navElements = document.querySelectorAll('.js-faq-nav')
  const noResult = document.querySelector('.js-faq-no-result')

  // 質問文（Q）は検索のたびに変化しないため、正規化済みの文字列を初期化時に用意しておく
  const categories = Array.from(document.querySelectorAll('.category-list')).map((list) => {
    const title = list.previousElementSibling
    return {
      list,
      title: title && title.classList.contains('category-title') ? title : null,
      questions: Array.from(list.querySelectorAll('.question_item')).map((item) => {
        // 回答文は対象にせず、質問文（Q）のみを検索対象にする
        const question = item.querySelector('.question')
        return { item, text: question ? normalize(question.textContent) : '' }
      }),
    }
  })

  // 検索前の初期状態に戻す
  const resetView = () => {
    navElements.forEach((el) => (el.hidden = false))
    categories.forEach(({ list, title, questions }) => {
      list.hidden = false
      if (title) title.hidden = false
      questions.forEach(({ item }) => (item.hidden = false))
    })
    if (noResult) noResult.hidden = true
  }

  const filter = (rawKeyword) => {
    const keyword = normalize(rawKeyword.trim())

    if (keyword === '') {
      resetView()
      return
    }

    // 検索中はトップ5・カテゴリーナビを非表示にする
    navElements.forEach((el) => (el.hidden = true))

    let totalMatched = 0
    categories.forEach(({ list, title, questions }) => {
      let categoryMatched = 0
      questions.forEach(({ item, text }) => {
        const matched = text.includes(keyword)
        item.hidden = !matched
        if (matched) categoryMatched += 1
      })

      // マッチした質問がないカテゴリーは見出しごと非表示にする
      list.hidden = categoryMatched === 0
      if (title) title.hidden = categoryMatched === 0
      totalMatched += categoryMatched
    })

    if (noResult) noResult.hidden = totalMatched !== 0
  }

  let isComposing = false
  let debounceTimerId = null

  const scheduleFilter = () => {
    if (debounceTimerId) clearTimeout(debounceTimerId)
    debounceTimerId = setTimeout(() => filter(searchInput.value), DEBOUNCE_DELAY_MS)
  }

  // IME変換中（未確定文字列）は絞り込まず、確定後にまとめて実行する
  searchInput.addEventListener('compositionstart', () => {
    isComposing = true
  })
  searchInput.addEventListener('compositionend', () => {
    isComposing = false
    scheduleFilter()
  })
  searchInput.addEventListener('input', () => {
    if (isComposing) return
    scheduleFilter()
  })
}
